import React from "react";
import { observer } from "mobx-react";
import styled from "styled-components";
import { Container, Typography, Box } from "@mui/material";
import { UserPreferencesForm } from "../components/UserPreferences";
import { userPreferencesController } from "../modules/controllers";
import { colors } from "../theme";

const Wrapper = styled.div`
  min-height: 100vh;
  background: linear-gradient(
    135deg,
    ${colors.background.light} 0%,
    ${colors.background.paper} 100%
  );
  padding: 20px 0;
`;

const HeaderSection = styled(Box)`
  background: ${colors.gradients.primary};
  color: white;
  padding: 40px 0;
  margin-bottom: 30px;
  text-align: center;
`;

const HeaderTitle = styled(Typography)`
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 10px;
`;

const HeaderSubtitle = styled(Typography)`
  font-size: 1.2rem;
  opacity: 0.9;
  max-width: 600px;
  margin: 0 auto;
`;

export const UserPreferences = observer(() => {
  return (
    <Wrapper>
      <HeaderSection>
        <Container maxWidth="lg">
          <HeaderTitle variant="h1">Your Culinary Profile</HeaderTitle>
          <HeaderSubtitle variant="subtitle1">
            Help us create the perfect meal plan by telling us about your
            favorite foods, allergies, and dietary goals. This information
            powers our AI to generate personalized recommendations just for you.
          </HeaderSubtitle>
        </Container>
      </HeaderSection>

      <Container maxWidth="lg">
        <UserPreferencesForm controller={userPreferencesController} />
      </Container>
    </Wrapper>
  );
});

export default UserPreferences;
